import './Card.scss';
import CustomPictureSlider from './CustomPictureSlider/CustomPictureSlider';
import Description from './Description/Description';

function Card({card}) {
    return (
        <div className='card'>
            <div className='container'>
                <CustomPictureSlider card={card}/>
                <Description card={card}/>
            </div>
        </div>
    )
}
export default Card;